export default function Footer() {
  return (
    <footer>
      <a href="#hero" className="footer-logo">Coleman <span>Auto</span></a>
      <span className="footer-copy">© 2025 Coleman Auto. Bryan, TX.</span>
      <span className="footer-area">Serving Brazos Valley & surrounding areas</span>
    </footer>
  )
}